import { useState, useCallback } from 'react';
import { useClient } from 'jsonapi-react';

export function useRetentionMetrics() {
  const [period, setPeriod] = useState(30);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [expandedTaxonomy, setExpandedTaxonomy] = useState(null);

  const client = useClient();

  const fetchMetrics = useCallback(
    async (days = 30) => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await client.fetch(`brain/metrics?period=${days}`);
        // brain/metrics returns plain JSON, not JSON:API format
        const responseData = response?.data || response;
        setData(responseData);
      } catch (err) {
        console.error('Error fetching retention metrics:', err);
        setError(err.message || 'Erro ao carregar métricas');
      } finally {
        setIsLoading(false);
      }
    },
    [client]
  );

  const changePeriod = useCallback(
    newPeriod => {
      setPeriod(newPeriod);
      fetchMetrics(newPeriod);
    },
    [fetchMetrics]
  );

  const toggleExpanded = useCallback(taxonomyId => {
    setExpandedTaxonomy(prev => (prev === taxonomyId ? null : taxonomyId));
  }, []);

  return {
    period,
    data,
    isLoading,
    error,
    expandedTaxonomy,
    fetchMetrics,
    changePeriod,
    toggleExpanded
  };
}
